import { Fragment } from 'react';
import { AutomaticReminderAlert } from './AutomaticReminderAlert';
import { CancelSignRequestButton } from './CancelSignRequestButton';
import { CancelSignRequestErrorAlert } from './CancelSignRequestErrorAlert';
import { PendingRecipients } from './PendingRecipients';
import { SendReminderButton } from './SendReminderButton';
import { SectionContent, SectionFooter } from '../../components';
import { ActivityTab } from '../ActivityTab';
import { SidebarTabs } from '../SidebarTabs';
import { AlertsContainer, FooterContainer } from './styled';
export function PendingState() {
    return (<Fragment>
      <SectionContent>
        <AlertsContainer>
          <CancelSignRequestErrorAlert />
        </AlertsContainer>
        <SidebarTabs recipients={<PendingRecipients />} activity={<ActivityTab />}/>
      </SectionContent>
      <SectionFooter>
        <AutomaticReminderAlert />
        <FooterContainer>
          <SendReminderButton />
          <CancelSignRequestButton />
        </FooterContainer>
      </SectionFooter>
    </Fragment>);
}
